var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconreports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.75V10.25H15.75V11.75H8.25ZM8.25 7.74995V6.25H15.75V7.74995H8.25ZM5.99997 14.25H13.5C13.9448 14.25 14.3564 14.3462 14.7346 14.5385C15.1128 14.7308 15.4339 15.0026 15.698 15.3538L18 18.3539V4.3077C18 4.21795 17.9711 4.14423 17.9134 4.08653C17.8557 4.02883 17.782 3.99997 17.6922 3.99997H6.3077C6.21795 3.99997 6.14423 4.02883 6.08652 4.08653C6.02882 4.14423 5.99997 4.21795 5.99997 4.3077V14.25ZM6.3077 20H17.3673L14.5173 16.2711C14.3916 16.1057 14.242 15.9775 14.0683 15.8865C13.8945 15.7955 13.7051 15.75 13.5 15.75H5.99997V19.6922C5.99997 19.782 6.02882 19.8557 6.08652 19.9134C6.14423 19.9711 6.21795 20 6.3077 20ZM17.6922 21.5H6.3077C5.80257 21.5 5.375 21.325 5.025 20.975C4.675 20.625 4.5 20.1974 4.5 19.6922V4.3077C4.5 3.80257 4.675 3.375 5.025 3.025C5.375 2.675 5.80257 2.5 6.3077 2.5H17.6922C18.1974 2.5 18.625 2.675 18.975 3.025C19.325 3.375 19.5 3.80257 19.5 4.3077V19.6922C19.5 20.1974 19.325 20.625 18.975 20.975C18.625 21.325 18.1974 21.5 17.6922 21.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconreports);
export default __webpack_public_path__ + "static/media/icon=reports.ea8ba2042ef588faeaa2d80973eb2ec2.svg";
export { ForwardRef as ReactComponent };